import BaseComponent from '../base/baseComponent';
import analyticsUtils from '../utilities/analyticsUtils';
export default class Tile extends BaseComponent {
    constructor(element) {
        super(element);
        this.listenLinksForDatalayer();
    }
    listenLinksForDatalayer() {
        let links = this._el.getElementsByTagName('a');
        [...links].forEach((link) => {
            link.addEventListener('click', async (e) => {
                e.preventDefault();
                let tileIndex = 0;
                let itemListId = analyticsUtils.getItemListId(this._el);
                let itemListName = analyticsUtils.getItemListName(this._el);
                if (itemListName === 'Listing Page' || itemListName === 'Wishlist') {
                    tileIndex = analyticsUtils.getTileIndex(this._el.closest('.product-tile'));
                }
                else if (itemListId === 'carousel_1') {
                    var productTile = this._el.closest('.experience-component.experience-molecules-productTile.swiper-slide');
                    tileIndex = analyticsUtils.getTileIndexFromCarousel(productTile);
                }
                let data = {
                    'forcedPipeline': 'ProductClick',
                    'pid': this._options.id,
                    'item_list_name': itemListName,
                    'item_list_id': itemListId,
                    'product_index': tileIndex,
                };
                analyticsUtils.passThroughProcessor(data, () => { window.location.href = link.href; });
            });
        });
    }
}
